(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.startTime = this.dataset.startTime;
      this.endTime = this.dataset.endTime;
      this.scheduleEnabled = this.dataset.schedule === 'true';
      
      const closeButton = this.querySelector('.announcement__close');
      const ad = window.sessionStorage.getItem('announcementDismissed');

      if (!ad) {
        this.classList.remove('hide');
      }

      if (closeButton) {
        closeButton.addEventListener('click', this.hideAnnouncement.bind(this));
      }
      
      // Only initialize scheduling if it's enabled
      if (this.scheduleEnabled && this.startTime && this.endTime) {
        this.initSchedule();
      }
    }

    hideAnnouncement() {
      window.sessionStorage.setItem('announcementDismissed', true);
      this.classList.add('announcement-bar--hide');

      setTimeout(() => {
        this.style.display = 'none';
      }, 300);
    }
    
    initSchedule() {
      // Initial check
      this.checkDateTimeRange();
      
      // Check every minute
      setInterval(() => {
        this.checkDateTimeRange();
      }, 60000);
    }
    
    checkDateTimeRange() {
      // Ensure moment.js is loaded
      if (typeof moment === 'undefined') {
        console.error('Moment.js is not loaded yet');
        return;
      }
      
      // Get the current time in CST
      const now = moment().tz("America/Chicago");
      
      // Parse start and end times in CST
      const startDate = moment(this.startTime).tz("America/Chicago");
      const endDate = moment(this.endTime).tz("America/Chicago");
      
      // Debug
      console.log('Current time:', now.format());
      console.log('Start time:', startDate.format());
      console.log('End time:', endDate.format());
      
      // Check if the current date is within the specified date range
      if (now >= startDate && now <= endDate) {
        // Show the announcement
        this.style.display = 'block';
        console.log('Announcement should be visible');
      } else {
        // Hide the announcement
        this.style.display = 'none';
        console.log('Announcement should be hidden');
      }
    }
  }

  // Wait for moment.js to load before initializing
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof moment !== 'undefined') {
      customElements.define('announcement-bar', AnnouncementBar);
    } else {
      console.error('Moment.js library not loaded');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-signup-banner"] && !Shopify.designMode) return;
  try {
    
  window.onload = () => {
    class SignupBanner extends HTMLElement {
      constructor() {
        super();

        this.signupForm = this.querySelector('.newsletter-form');

        if (this.signupForm) {
          this.submitButton = this.signupForm.querySelector('button[type="submit"]');

          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }

          clearInputErrors(this.signupForm);

          this.signupForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      handleSubmit(evt) {
        const formIsValid = validateForm(this.signupForm);

        if (formIsValid) {
          if (this.submitButton) {
            this.submitButton.classList.add('btn--loading');
          }
        } else {
          evt.preventDefault();
        }
      }
    }

    customElements.define('signup-banner', SignupBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-linked-menu"]) return;
  try {
    
  class FaqLinkedMenu extends HTMLElement {
    constructor() {
      super();
      this.faqLinkedMenuContent = this.querySelector('.faq-linked-menu-content');
      this.accordionComponent = document.querySelectorAll('.faq-item');
      const faqlinkedItems = [];

      this.accordionComponent.forEach((elm, i) => {
        if (i != 0) {
          elm.classList.add('hide');
        }

        const faqLinkedMenuSection = elm.querySelector('[data-menu-info="faq-linked-menu"]');

        if (faqLinkedMenuSection) {
          const newMenuItem = document.createElement('li');
          newMenuItem.dataset.linkType = elm.dataset.sectionType;
          newMenuItem.innerHTML = faqLinkedMenuSection.innerHTML;

          if (i === 0) {
            newMenuItem.classList.add('active');
          }

          this.faqLinkedMenuContent.appendChild(newMenuItem);

          newMenuItem.addEventListener('click', this.handleClick.bind(this));
        }

        faqLinkedMenuSection.classList.add('hide');
      });
    }

    handleClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const contentId = target.dataset.linkType;

      const activeElement = document.querySelector(`[data-section-type=${contentId}]`);
      const activeHeaderItem = this.faqLinkedMenuContent.querySelector('li.active');

      if (activeHeaderItem !== target) {
        activeHeaderItem.classList.remove('active');
        target.classList.add('active');
      }

      this.accordionComponent.forEach((elm) => {
        if (!elm.classList.contains('hide')) {
          elm.classList.add('collapsible-content--hide');
          setTimeout(function () {
            elm.classList.add('hide');
          }, 200);
        }
      });

      setTimeout(function () {
        activeElement.classList.remove('hide');
        activeElement.classList.remove('collapsible-content--hide');
      }, 200);
    }
  }

  customElements.define('faq-linked-menu', FaqLinkedMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  function toggleContent(event) {
      event.preventDefault();
      
      const targetId = event.currentTarget.getAttribute('data-target');
      const content = document.getElementById(targetId);
      const showLink = event.currentTarget;

      if (content.style.display === 'block') {
          content.style.display = 'none';
          showLink.textContent = '+';
      } else {
          content.style.display = 'block';
          showLink.textContent = '-';
      }
  }

  // Apply toggle functionality only for screens under 768px
  if (window.matchMedia('(max-width: 767px)').matches) {
    document.querySelectorAll('.toggle').forEach(link => {
      link.addEventListener('click', toggleContent);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.background = this.getAttribute('data-background');
      this.applyColorScheme = this.getAttribute('data-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.headerHeight = this.header.getBoundingClientRect().height;
      this.headerWrap = this.header.querySelector('.header-wrapper');
      this.isFrosted = this.headerWrap.dataset.frosted;
      this.isSticky = this.headerWrap.dataset.sticky;
      this.menuInline = this.header.querySelector('.list-menu--inline');
      this.activeMenuItem = this.header.querySelector('.header__active-menu-item');
      this.listMenuItems = this.header.querySelectorAll('.header__inline-menu .list-menu__item-list');

      this.openingMenu = false;
      this.closingMenu = false;
      this.isFadeOutTransition = false;
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseenter', this.handleMouseEnter.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('mouseleave', this.handleMouseleave.bind(this)));
      this.listMenuItems.forEach((summary) => summary.addEventListener('click', this.handleClick.bind(this)));

      if (this.isSticky) {
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      const searchHomeField = document.getElementById('search-home-field');
      let headerHeight = this.header.getBoundingClientRect().height;
      if (searchHomeField) {
        headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
        if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
          searchHomeField.classList.add('search-home--transparent');
        }
      }
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      let prevHeight = 0;
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.contentBoxSize) {
            const height = entry.contentBoxSize?.[0].blockSize;
            if (typeof height === 'number' && height !== prevHeight) {
              prevHeight = height;
              let headerHeight = this.header.getBoundingClientRect().height;
              if (searchHomeField) {
                headerHeight = headerHeight + searchHomeField.getBoundingClientRect().height;
              }
              document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }
          }
        }
      });

      resizeObserver.observe(this.header);
      this.setupTransparency();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:unload', this.setupTransparency.bind(this));
        document.addEventListener('shopify:section:reorder', this.setupTransparency.bind(this));
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      if (!this.applyColorScheme) {
        this.header.classList.add(this.background);
      }
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      if (!this.applyColorScheme) {
        this.header.classList.remove(this.background);
      }
    }

    handleClick(event) {
      const summaryElm = event.target;
      const menuItem = summaryElm.closest('.list-menu__item-list');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      this.header.classList.add(this.background, 'is-filled');
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseEnter(event) {
      const menuItem = event.target;
      const menuItemSpan = menuItem.querySelector('.header__menu-item');
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });
      menuItemSpan.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.closingMenu && detailsElement.getAttribute('open') && !this.isFadeOutTransition) {
        window.clearTimeout(this.timeoutClose);
        this.closingMenu = false;
      }

      if (detailsElement.getAttribute('open') && !this.isFadeOutTransition) return;

      window.clearTimeout(this.timeoutOpen);
      this.openingMenu = true;

      this.timeoutOpen = setTimeout(() => {
        this.openingMenu = false;
        this.openSubMenu(detailsElement);
      }, 300);
    }

    openSubMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
      if (this.isFrosted) this.headerWrap.classList.remove('frosted-header-glass');
      this.header.classList.add(this.background, 'is-filled');
      setTimeout(() => {
        detailsElement.classList.add('sub-menu-opening');
      });
    }

    handleMouseleave(event) {
      const menuItem = event.target;
      const detailsElement = menuItem.querySelector('.details--list-menu');
      const currentSubmenu = this.menuInline.querySelector('details[open]');

      this.header.querySelectorAll('.header__active-menu-item').forEach((elm) => {
        elm.classList.remove('header__active-menu-item');
      });

      if (this.activeMenuItem) this.activeMenuItem.classList.add('header__active-menu-item');

      if (!detailsElement) return;

      if (this.openingMenu && !detailsElement.getAttribute('open')) {
        window.clearTimeout(this.timeoutOpen);
        this.openingMenu = false;
      }

      if (!detailsElement.getAttribute('open')) return;

      this.closingMenu = true;
      this.timeoutClose = setTimeout(() => {
        this.closingMenu = false;
        this.closeSubMenu(detailsElement);
      }, 300);
    }

    closeSubMenu(detailsElement) {
      if (this.isFrosted) this.headerWrap.classList.add('frosted-header-glass');
      this.header.classList.remove('is-filled');
      if (!this.header.classList.contains('animate')) {
        this.header.classList.remove(this.background);
      }

      detailsElement.classList.remove('sub-menu-opening');
      this.isFadeOutTransition = true;

      detailsElement.addEventListener(
        'transitionend',
        () => {
          detailsElement.removeAttribute('open');
          this.isFadeOutTransition = false;
        },
        { once: true }
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        // this.searchModal.close(false);
      }
    }

    setupTransparency() {
      if (document.querySelector('.shopify-section:first-child [allow-transparent-header]')) {
        this.classList.add(this.background);
        this.setAttribute('data-transparency', true);
      } else {
        if (this.isSticky && !this.applyColorScheme) {
          this.classList.remove(this.background);
        }
        this.removeAttribute('data-transparency');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
var elem = document.querySelector('.carousel');

console.log("Selected element:", elem);

var flkty = new Flickity(elem, {
  // options
  cellAlign: 'left',
  contain: true
});

// element argument can be a selector string
//   for an individual element
var flkty = new Flickity('.carousel', {
  // options
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn-with-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const scrollContainer = document.querySelector('.multicolumn__list');
  const container = scrollContainer.parentElement;
  
  // Create a custom scrollbar
  const scrollbar = document.createElement('div');
  scrollbar.className = 'custom-scrollbar';
  
  const scrollThumb = document.createElement('div');
  scrollThumb.className = 'custom-scrollbar-thumb';
  scrollbar.appendChild(scrollThumb);
  
  container.appendChild(scrollbar);
  
  // Update thumb position on scroll
  scrollContainer.addEventListener('scroll', updateScrollThumb);
  
  function updateScrollThumb() {
    const scrollRatio = scrollContainer.scrollLeft / (scrollContainer.scrollWidth - scrollContainer.clientWidth);
    const thumbPosition = scrollRatio * (scrollbar.clientWidth - scrollThumb.clientWidth);
    scrollThumb.style.transform = `translateX(${thumbPosition}px)`;
  }
  
  // Initial update
  updateScrollThumb();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"]) return;
  try {
    
  class newsletterForm extends HTMLElement {
    constructor() {
      super();
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      const sectionId = this.dataset.sectionId;
      const contactNewsletter = this.querySelector(`#Contact_${sectionId}`);
      const inputEmailGroup = contactNewsletter.querySelector('.input-group');
      const inputEmailNewsletter = contactNewsletter.querySelector('input[type="email"]');
      const errorMessage = contactNewsletter.querySelector(`#Newsletter-error--${sectionId}`);
      const errorMessageText = errorMessage.querySelector('.input-error-message__text');
      const iconError = contactNewsletter.querySelector('.field-wrapper__icon-error');
      const existingEmailMsg = contactNewsletter.querySelector('.newsletter-email-exist');
      const urlUserCame = document.referrer ? new URL(document.referrer) : null;

      inputEmailNewsletter.addEventListener('keyup', function (e) {
        if (e.code === 'Enter') return;
        inputEmailGroup.classList.remove('input-group--error');
        inputEmailNewsletter.classList.remove('input--error');
        errorMessage.classList.add('hide');
        iconError.classList.add('hide');
        if (existingEmailMsg) existingEmailMsg.classList.add('hide');
      });

      if (existingEmailMsg && searchParams.has('form_type') && inputEmailNewsletter.value) {
        existingEmailMsg.classList.remove('hide');
      }

      if ( urlUserCame && urlUserCame.pathname === '/challenge' ) {
        document.querySelector(`#Contact_${sectionId}`).scrollIntoView();
      }

      contactNewsletter.addEventListener('submit', (event) => {
        const email = inputEmailNewsletter.value;

        if (!this.validateEmail(email)) {
          event.preventDefault();
          var erroMessage = '';

          if (email === '') {
            erroMessage = window.loginStrings.errorEmailRequired;
          } else {
            erroMessage = window.loginStrings.errorEmailInvalid;
          }

          inputEmailGroup.classList.add('input-group--error');
          inputEmailNewsletter.classList.add('input--error');
          inputEmailNewsletter.setAttribute('aria_invalid', 'true');
          inputEmailNewsletter.setAttribute('aria_describedby', `Newsletter-error--${sectionId}`);
          inputEmailNewsletter.setAttribute('data_form_status', true);

          if (errorMessageText) errorMessageText.textContent = erroMessage;
          errorMessage.classList.remove('hide');
          iconError.classList.remove('hide');
          inputEmailNewsletter.focus();
        }

        return false;
      });
    }

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  }

  customElements.define('newsletter-form', newsletterForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-featured-collection-10-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔍 Script initialized');

  function initRelatedProducts() {
    const relatedProducts = document.querySelectorAll('.related-product');
    console.log('Found related products:', relatedProducts.length);

    relatedProducts.forEach((product, index) => {
      product.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('🖱️ Related product clicked:', this.dataset);
        
        const slideContainer = this.closest('.swiper-slide');
        if (!slideContainer) {
          console.error('Could not find parent slide container');
          return;
        }
        
        updateMainImage(slideContainer, this.dataset);
        updateProductDetails(slideContainer, this.dataset);
        updateProductURL(slideContainer, this.dataset);
      });
    });
  }

  function updateMainImage(container, data) {
    // Single image case
    const singleImageLink = container.querySelector('a.featured-image-' + getSectionId(container));
    const singleImage = container.querySelector('a.featured-image-' + getSectionId(container) + ' img, div.featured-image-' + getSectionId(container) + ' img');
    
    // Gallery case
    const swiperGallery = container.querySelector('.featured-media-slider-' + getSectionId(container));
    
    if (swiperGallery) {
      const allSlides = swiperGallery.querySelectorAll('.swiper-slide img');
      allSlides.forEach(img => {
        img.src = data.mainImage;
        img.alt = data.mainTitle;
      });
      
      const slideLinks = swiperGallery.querySelectorAll('.swiper-slide a');
      slideLinks.forEach(link => {
        link.href = data.mainUrl;
      });
    } else if (singleImage) {
      singleImage.src = data.mainImage;
      singleImage.alt = data.mainTitle;
      if (singleImageLink) {
        singleImageLink.href = data.mainUrl;
      }
    }
  }

  function updateProductDetails(container, data) {
    const titleElement = container.querySelector('[class*="featured-title-"]');
    if (titleElement) {
      const productTitle = titleElement.querySelector('.product-title');
      const productSubtitle = titleElement.querySelector('.product-subtitle');
      
      if (productTitle) {
        productTitle.textContent = data.mainTitle;
      }
      if (productSubtitle) {
        productSubtitle.textContent = data.mainSubtitle || '';
      }
    }

    const priceContainer = container.querySelector('[class*="featured-price-"]');
    if (priceContainer) {
      const regularPrice = priceContainer.querySelector('[class*="featured-regular-price-"]');
      const comparePrice = priceContainer.querySelector('[class*="featured-compare-price-"]');
      const separator = priceContainer.querySelector('strong');
      
      if (regularPrice) {
        regularPrice.innerHTML = `<span class='money'>${data.mainPriceCurrent}</span>`;
      }
      
      if (data.mainPriceCompare) {
        if (!comparePrice) {
          if (separator) separator.style.display = 'inline';
          const newComparePrice = document.createElement('p');
          newComparePrice.className = 'featured-compare-price-' + getSectionId(container);
          newComparePrice.innerHTML = `<span class='money'>${data.mainPriceCompare}</span>`;
          priceContainer.appendChild(newComparePrice);
        } else {
          comparePrice.innerHTML = `<span class='money'>${data.mainPriceCompare}</span>`;
          comparePrice.style.display = 'inline';
          if (separator) separator.style.display = 'inline';
        }
      } else {
        if (comparePrice) comparePrice.style.display = 'none';
        if (separator) separator.style.display = 'none';
      }
    }
  }

  function updateProductURL(container, data) {
    // Update all clickable elements
    const clickableElements = container.querySelectorAll('a[class*="featured-"]');
    clickableElements.forEach(element => {
      element.href = data.mainUrl;
    });
  }

  function getSectionId(container) {
    const classWithId = Array.from(container.classList).find(className => className.startsWith('featured-slide-'));
    return classWithId ? classWithId.split('featured-slide-')[1] : '';
  }

  // Initialize on page load
  initRelatedProducts();

  // Re-initialize when Shopify editor loads section
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initRelatedProducts);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections-scroll-2"] && !Shopify.designMode) return;
  try {
    
const nextButtons = document.querySelectorAll('.next-btn_2');
const prevButtons = document.querySelectorAll('.prev-btn_2');

const itemWidth = 150;
const padding = 10;
let currentIndex = 0;

nextButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const list = button.parentElement.querySelector('.item-list_2');
    currentIndex++;
    if (currentIndex >= list.children.length) {
      currentIndex = 0;
      list.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      list.scrollTo({ left: currentIndex * (itemWidth + padding), behavior: 'smooth' });
    }
  });
});

prevButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const list = button.parentElement.querySelector('.item-list_2');
    currentIndex--;
    if (currentIndex < 0) {
      currentIndex = list.children.length - 1;
      list.scrollTo({ left: list.scrollWidth - list.clientWidth, behavior: 'smooth' });
    } else {
      list.scrollTo({ left: currentIndex * (itemWidth + padding), behavior: 'smooth' });
    }
  });
});

// Swiper initialization
const swiper = new Swiper('.swiper-container_2', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  
  // Enable mousewheel control
  mousewheel: true,
  simulateTouch: true,

   scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
  
  // If you need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections-scroll"] && !Shopify.designMode) return;
  try {
    
const nextButtons = document.querySelectorAll('.next-btn');
const prevButtons = document.querySelectorAll('.prev-btn');

const itemWidth = 150;
const padding = 10;
let currentIndex = 0;

nextButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const list = button.parentElement.querySelector('.item-list');
    currentIndex++;
    if (currentIndex >= list.children.length) {
      currentIndex = 0;
      list.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      list.scrollTo({ left: currentIndex * (itemWidth + padding), behavior: 'smooth' });
    }
  });
});

prevButtons.forEach((button) => {
  button.addEventListener('click', () => {
    const list = button.parentElement.querySelector('.item-list');
    currentIndex--;
    if (currentIndex < 0) {
      currentIndex = list.children.length - 1;
      list.scrollTo({ left: list.scrollWidth - list.clientWidth, behavior: 'smooth' });
    } else {
      list.scrollTo({ left: currentIndex * (itemWidth + padding), behavior: 'smooth' });
    }
  });
});

// Swiper initialization
const swiper = new Swiper('.swiper-container', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  
  // Enable mousewheel control
  mousewheel: true,
  simulateTouch: true,

   scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
  
  // If you need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

  } catch(e) { console.error(e); }
})();
})();
